import OpenAI from 'openai';
import auth from '~/auth';

/**
 * Creates an OpenAI client configured to call our backend proxy (`/api/openai`)
 * instead of `api.openai.com`. The user's JWT is injected via a custom fetch so
 * the proxy can authenticate the request server-side.
 *
 * The `apiKey` value is a placeholder — it satisfies the SDK constructor but is
 * never sent to OpenAI. The real API key lives exclusively on the server.
 */
export function createOpenAIClient(): OpenAI {
  return new OpenAI({
    apiKey: 'proxy-placeholder',
    baseURL: `${window.location.origin}/api/openai`,
    dangerouslyAllowBrowser: true,
    fetch: async (url: RequestInfo, init?: RequestInit) => {
      const token = await auth.getAccessToken();
      const headers = new Headers(init?.headers);

      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }

      return window.fetch(url, { ...init, headers });
    },
  });
}
